module.exports = __webpack_public_path__ + "img/ukraine.05bc6af9.svg";